import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of, shareReplay } from 'rxjs';

@Pipe({
  name: 'castObservable',
  standalone: true,
})
export class CastObservablePipe implements PipeTransform {
  transform(value: unknown): Observable<any> {
    return (value instanceof Observable ? value : of(value)).pipe(
      shareReplay(1)
    );
  }
}
